/** Locale-aware alphabetical sort for string ids/keys (Sonar S2871). */
export function sortAlphabetically(values: string[]): string[] {
  return [...values].sort((a, b) => a.localeCompare(b));
}
